import DocumentEditorToolBar from './DocumentEditorToolBar';

export default DocumentEditorToolBar;
